import ApplicationSerializer from 'cio/serializers/application';
import DS, { ModelSchema } from 'ember-data';
import { CampaignUpdateTypes } from 'cio/models/campaign';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class CampaignSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    tags: { serialize: 'ids' },
    createdByUser: {
      serialize: false,
      deserialize: 'records',
    },
    updatedByUser: {
      serialize: false,
      deserialize: 'records',
    },
    // Copy is an attribute only used internally to track temporary campaigns
    // created while copying in the VWB
    _copy: {
      serialize: false,
    },
  },
}) {
  serialize(snapshot: DS.Snapshot, options: Record<string, any>) {
    let json: Record<string, any> = super.serialize(snapshot, options);

    if (json.update_type === CampaignUpdateTypes.State) {
      json.state = json.state_action;
    }
    delete json.state_action; // never read by the back-end, used only for setting "state" ^

    return json;
  }

  normalizeResponse(
    store: DS.Store,
    type: ModelSchema<keyof ModelRegistry>,
    payload: Record<string, any>,
    id: string,
    requestType: string,
  ) {
    // always set "update_type" and "state_action" to null
    // those attributes are only relevant for outgoing save/update requests
    // clearing them ensures Ember Data records in store don't hold any leftover values
    let addNullStateActionAndUpdateType = (campaign: Record<string, any>) => {
      campaign.update_type = null;
      campaign.state_action = null;
    };

    if (payload.campaigns) {
      payload.campaigns.forEach(addNullStateActionAndUpdateType);
    } else if (payload.campaign) {
      addNullStateActionAndUpdateType(payload.campaign);
    }

    return super.normalizeResponse(store, type, payload, id, requestType);
  }
}
